import { WithContext, VideoObject as VideoObjectSchema } from 'schema-dts';

import config from 'config';
import VideoFile from 'types/VideoFile';
import getCloudflareVideoThumbnail from 'utils/getCloudflareVideoThumbnail';
import getIsoDuration from 'utils/getIsoDuration';
import resolveVideoUrl from 'utils/resolveVideoUrl';

type Video = {
  id: number;
  title: string;
  description: string;
  file: VideoFile;
};

const getVideoStructuredData = (video: Video): WithContext<VideoObjectSchema> => {
  const uid = video?.file ? resolveVideoUrl(video.file) : '';
  const structuredData: WithContext<VideoObjectSchema> = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: video?.title,
    description: video?.description,
    thumbnailUrl: [getCloudflareVideoThumbnail(uid)],
    uploadDate: video?.file?.createdAt,
    duration: getIsoDuration(video?.file?.duration || 0),
    contentUrl: `https://customer-${config.cfCustomerSubdomain}.cloudflarestream.com/${uid}/manifest/video.m3u8`,
  };
  return structuredData;
};

export default getVideoStructuredData;
